<template>
  <div class="my">
    <router-link :to="{ path: '/my/card' }" tag="div" class="my_header">
      <div class="header_left">
        <img :src="userInfo.avatar" />
      </div>
      <div class="header_center">
        <p>{{ userInfo.nickname }}</p>
        <!-- <p>你还未完善名片</p> -->
      </div>
      <div class="header_right">
        <span>完善名片</span>
        <van-icon name="arrow" size=".26rem" color="#999999" />
      </div>
    </router-link>
    <div class="my_vip" @click="goBuy(userInfo.level)">
      <div class="vip_left">
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_my_vip.png"
        />
        <span v-if="userInfo.level == 0">开通会员尊享多项特权</span>
        <span v-if="userInfo.level == 1">您好，尊贵的超级会员</span>
      </div>
      <div class="vip_right1" v-if="userInfo.level == 0">
        <span>开通会员</span>
        <img
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_my_vip_go.png"
        />
      </div>
      <div class="vip_right" v-if="userInfo.level == 1">
        <span>{{ (userInfo.clean_time * 1000) | dateFormat }}</span>
        <span>到期</span>
      </div>
    </div>
    <div class="my_company">
      <div class="company_left">
        <span>我的公司（品牌）</span>
      </div>
      <router-link
        :to="{ path: '/jiaodian/brand/addBrand' }"
        tag="div"
        class="company_right"
      >
        <span>
          {{ brandList.length != 0 ? brandList[0].title : "添加品牌" }}
        </span>
        <van-icon name="arrow" size=".26rem" color="#999999" />
      </router-link>
    </div>
    <div class="my_company">
      <div class="company_left">
        <span>我的需求</span>
      </div>
      <div @click="xuqiuShow = true" class="company_right">
        <span class="van-ellipsis">{{ xuqiu || "设置" }}</span>
        <van-icon name="arrow" size=".26rem" color="#999999" />
      </div>
    </div>
    <div class="my_company">
      <div class="company_left">
        <span>我的招商项目</span>
      </div>
      <router-link
        :to="{ path: '/project/list' }"
        tag="div"
        class="company_right"
      >
        <span class="van-ellipsis">{{ isProject }}</span>
        <van-icon name="arrow" size=".26rem" color="#999999" />
      </router-link>
    </div>
    <div class="my_nav">
      <div
        class="nav_item"
        v-for="item in MyMenus"
        :key="item.name"
        @click="goPage(item)"
      >
        <img :src="item.pic" />
        <p>{{ item.name }}</p>
      </div>
    </div>
    <router-link to="/my/privacy" tag="div" class="my_agreement"
      >《用户服务和隐私协议》</router-link
    >
    <van-popup v-model="showPopup" round style="width: 70%">
      <div class="pop">
        <div class="title">输入团队名称</div>
        <div class="textarea van-hairline--surround">
          <van-field
            v-model="teamName"
            rows="1"
            type="textarea"
            maxlength="15"
            placeholder="请输入团队名称..."
            show-word-limit
          />
        </div>
        <div class="btn van-hairline--top">
          <div class="close van-hairline--right" @click="showPopup = false">
            取消
          </div>
          <div class="confirm" @click="goTeam">确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup
      class="code_box"
      v-model="kefushow"
      closeable
      round
      position="bottom"
    >
      <div class="code_header">咨询师二维码</div>
      <div class="img_box">
        <img :src="codeImg" />
      </div>
      <!-- <div class="code_btn" @click="downloadCodeImg()">下载二维码</div> -->
    </van-popup>
    <van-popup class="xuqiu_pop" position="bottom" round v-model="xuqiuShow">
      <div class="xuqiu_top">
        为你推荐精准人脉
        <van-icon
          class="xuqiu_close"
          color="#999999"
          name="cross"
          @click="xuqiuShow = false"
        />
      </div>
      <div class="xuqiu_list">
        <div class="item_title">你是</div>
        <div class="item_list">
          <div
            :class="item.is_click == 1 ? 'item active' : 'item'"
            v-for="(item, index) in demandList.youre"
            :key="index"
            @click="seclectXuQiu(0, item.id)"
          >
            {{ item.demand_name }}
          </div>
        </div>
        <div class="item_title">你想</div>
        <div class="item_list">
          <div
            :class="item.is_click == 1 ? 'item active' : 'item'"
            v-for="(item, index) in demandList.would_you"
            :key="index"
            @click="seclectXuQiu(1, item.id)"
          >
            {{ item.demand_name }}
          </div>
        </div>
      </div>
      <div class="xuqiu_btn">
        <!-- <div class="btn_item" @click="deleteXuQiu">重置</div> -->
        <div class="btn_item sub" @click="submit">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Popup, Field, Icon, Toast } from "vant";
import { getUser, getMenuUser } from "@api/user";
import { getTeamList, getFollowLstNew, getProjectListNew } from "@/api/public";
import { getDemandList, postAddDemand, getFaceCode } from "@/api/lcapi";
import moment from "moment";
export default {
  name: "My",
  components: {
    [Dialog.name]: Dialog,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon
  },
  props: {},
  data() {
    return {
      userInfo: "",
      MyMenus: [],
      showPopup: false, // 创建团队弹窗
      teamName: "", // 创建团队名称
      teamStatus: false, // 是否有团队
      brandList: "", // 品牌列表
      kefushow: false, // 客服弹窗
      isProject: "",
      xuqiu: "",
      xuqiuShow: false,
      demandList: "",
      xuqiuActive: [],
      codeImg: ""
    };
  },
  filters: {
    dateFormat: function(value) {
      return moment(value).format("YYYY.MM.DD");
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.getTeamList();
    this.getFollowLstNew();
    this.getProjectListNew();
    this.getDemandList();
  },
  methods: {
    /**
     * 购买会员
     */
    goBuy(level) {
      if (level == 1) return;
      this.$router.push({
        path: "/member"
      });
    },
    /**
     * 获取需求
     */
    getDemandList() {
      let str = "";
      getDemandList().then(res => {
        let demandList = res.data;
        this.demandList = demandList;
        res.data.would_you.forEach(item => {
          if (item.is_click == 1) {
            str += item.demand_name + "、";
            this.xuqiuActive.push(item.id);
          }
        });
        res.data.youre.forEach(item => {
          if (item.is_click == 1) {
            this.xuqiuActive.push(item.id);
          }
        });
        str = str.substr(0, str.length - 1);
        this.xuqiu = str;
      });
    },
    // 获取项目列表
    getProjectListNew() {
      getProjectListNew().then(res => {
        if (res.data.length < 1) {
          this.isProject = "还没有发布过哦~";
        } else {
          this.isProject = res.data[0].title;
        }
      });
    },
    /**
     * 跳转页面
     */
    goPage(item) {
      console.log(item);
      if (item.wap_url == "/my/team") {
        if (this.teamStatus) {
          this.$router.push({ path: item.wap_url });
          return;
        } else {
          Toast({ message: "暂无团队" });
        }
        // Dialog.alert({
        //   message:
        //     "团队成员可以共享文章和视频\n每个成员分享或创建的都可被团队共用\n\n\n你可以创建团队或者加入团队",
        //   theme: "round-button",
        //   closeOnClickOverlay: true,
        //   confirmButtonText: "创建团队",
        //   confirmButtonColor: "#ff410a",
        // })
        //   .then(() => {
        //     this.showPopup = true;
        //   })
        //   .catch(() => {});
        // return;
        return;
      }
      if (item.wap_url == "/jiaodian/userWeizhan") {
        this.$router.push({
          path: item.wap_url,
          query: { uid: this.userInfo.uid }
        });
        return;
      }
      if (item.wap_url == "/my/code_list") {
        // this.$router.push({
        //   path: item.wap_url,
        //   query: { uid: this.userInfo.uid },
        // });
        this.getFaceCode();
        return;
      }
      this.$router.push({
        path: item.wap_url
      });
    },
    /**
     * 获取个人信息
     */
    User() {
      const that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    /**
     * 获取菜单信息
     */
    MenuUser() {
      let that = this;
      getMenuUser({ from: "wap" }).then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    /**
     * 跳转团队页
     */
    goTeam() {
      if (this.teamName == "") {
        Toast({ message: "请输入团队名称" });
        return;
      }
      this.$router.push({ name: "MyTeam" });
    },
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList()
        .then(res => {
          this.teamStatus = true;
        })
        .catch(err => {
          if (err.data.msg == "数据不存在！") {
            this.teamStatus = false;
          }
        });
    },
    /**
     * 我的关注 行业/品牌
     */
    getFollowLstNew() {
      getFollowLstNew().then(res => {
        this.brandList = res.data.brand;
      });
    },
    /**
     * 拨打电话
     */
    boTel(e) {
      window.location.href = "tel://" + e;
    },
    /**
     * 需求选择
     */
    seclectXuQiu(type, id) {
      if (type == 0) {
        this.demandList.youre.forEach(item => {
          if (item.id == id) {
            if (item.is_click == 1) {
              item.is_click = 0;
              let index = this.xuqiuActive.indexOf(item.id);
              this.xuqiuActive.splice(index, 1);
            } else {
              item.is_click = 1;
              this.xuqiuActive.push(item.id);
            }
          }
        });
      } else if (type == 1) {
        this.demandList.would_you.forEach(item => {
          if (item.id == id) {
            if (item.is_click == 1) {
              item.is_click = 0;
              let index = this.xuqiuActive.indexOf(item.id);
              this.xuqiuActive.splice(index, 1);
            } else {
              item.is_click = 1;
              this.xuqiuActive.push(item.id);
            }
          }
        });
      }
    },

    /**
     * 确定
     */
    submit() {
      let demand_id = JSON.stringify(this.xuqiuActive).replace(/\[|]/g, "");
      this.xuqiuShow = false;
      postAddDemand({ demand_id: demand_id }).then(res => {
        this.getDemandList();
      });
    },
    /**
     * 下载二维码
     */
    downloadCodeImg() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.codeImg;
      a.click();
    },
    /**
     * 获取二维码列表
     */
    getFaceCode() {
      getFaceCode()
        .then(res => {
          if (res.status == 200) {
            this.codeImg = res.data[0].cr_code;
            this.kefushow = true;
          } else {
            Toast({ message: "暂无数据" });
          }
        })
        .catch(err => {
          Toast({ message: "暂无数据" });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.my {
  min-height: 100vh;
  background: linear-gradient(180deg, #fefefe, #f6f6f6);
  padding-bottom: 1.2rem;
  .my_header {
    display: flex;
    height: 1.6rem;
    justify-content: space-between;
    align-items: center;
    margin: 0 0.3rem;
    background: #ffffff;
    .header_left {
      width: 1rem;
      font-size: 0;
      img {
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
      }
    }
    .header_center {
      flex: 1;
      padding-left: 0.3rem;
      font-weight: bold;
      color: #000000;
      font-size: 0.34rem;
      letter-spacing: 0.04rem;
      // p:first-child {
      //   font-weight: bold;
      //   color: #000000;
      //   font-size: 0.34rem;
      //   letter-spacing: 0.04rem;
      //   line-height: 0.5rem;
      //   height: 0.5rem;
      // }
      // p:last-child {
      //   line-height: 0.5rem;
      //   font-size: 0.24rem;
      //   color: #ff410a;
      //   height: 0.5rem;
      // }
    }
    .header_right {
      display: flex;
      align-items: center;
      font-size: 0;
      span {
        font-size: 0.26rem;
        color: #939393;
        line-height: 0.26rem;
      }
      img {
        width: 0.13rem;
        height: 0.26rem;
      }
    }
  }
  .my_vip {
    margin: 0.16rem 0.3rem 0 0.3rem;
    height: 0.94rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.24rem 0 0.3rem;
    color: #321400;
    position: relative;
    background-image: url("http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_vip_bg.png");
    background-size: 100% 100%;
    .vip_left {
      font-size: 0;
      display: flex;
      align-items: center;
      img {
        width: 0.32rem;
        height: 0.28rem;
      }
      span {
        font-size: 0.28rem;
        padding-left: 0.12rem;
        font-weight: bold;
      }
    }
    .vip_right {
      font-size: 0;
      display: flex;
      align-items: center;
      display: table-cell;
      vertical-align: bottom;
      img {
        width: 0.26rem;
        height: 0.26rem;
      }
      span {
        font-size: 0.26rem;
        margin-right: 0.1rem;
      }
    }
    .vip_right1 {
      font-size: 0;
      display: flex;
      align-items: center;
      img {
        width: 0.26rem;
        height: 0.26rem;
      }
      span {
        font-size: 0.26rem;
        margin-right: 0.1rem;
      }
    }
  }
  .my_company {
    margin: 0.24rem 0.3rem 0 0.3rem;
    height: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    .company_left {
      padding-left: 0.3rem;
      font-size: 0.28rem;
      width: 50%;
    }
    .company_right {
      width: 50%;
      font-size: 0;
      display: flex;
      align-items: center;
      padding-right: 0.4rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span {
        display: inline-block;
        width: calc(100% - 0.26rem);
        font-size: 0.26rem;
        line-height: 0.26rem;
        text-align: right;
      }
      i {
        width: 0.26rem;
      }
    }
  }
  .my_nav {
    margin: 0.24rem 0.3rem 0 0.3rem;
    background: #fff;
    border-radius: 0.1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-bottom: 0.5rem;
    .nav_item {
      width: calc(100% / 4);
      font-size: 0;
      text-align: center;
      padding-top: 0.5rem;
      img {
        width: 0.44rem;
        height: 0.44rem;
        display: block;
        margin: 0 auto;
      }
      p {
        margin-top: 0.2rem;
        font-size: 0.26rem;
        color: #575757;
      }
    }
  }
  .my_agreement {
    font-size: 0.26rem;
    color: #737f97;
    margin-top: 0.5rem;
    text-align: center;
  }
  .pop {
    .title {
      text-align: center;
      font-size: 0.24rem;
      font-weight: bold;
      line-height: 0.8rem;
    }
    .textarea {
      margin: 0 0.3rem;
    }
    .btn {
      display: flex;
      justify-content: space-between;
      line-height: 0.8rem;
      text-align: center;
      margin-top: 0.36rem;
      div {
        flex: 1;
        font-size: 0.24rem;
      }
      .close {
        color: #000;
      }
      .confirm {
        color: #ff410a;
      }
    }
  }
  .van-popup--center.van-popup--round {
    border-radius: 0.1rem;
  }
  .van-field--min-height .van-field__control {
    min-height: 0;
  }
  [class*="van-hairline"]::after {
    border-color: #999999;
  }
  .code_box {
    text-align: center;
    padding: 0.32rem;
    padding-bottom: 1rem;
    .code_header {
      font-size: 0.34rem;
      font-weight: bold;
      margin: 0.5rem 0;
    }
    .img_box {
      width: 3rem;
      height: 3rem;
      margin: 0 auto;
      border-radius: 0.06rem;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .code_btn {
      width: 4rem;
      height: 0.8rem;
      background: #ff410a;
      border: 0.01rem solid #ff410a;
      border-radius: 0.4rem;
      color: #fff;
      line-height: 0.78rem;
      margin: 0.5rem auto;
    }
  }
  .xuqiu_pop {
    max-height: 60vh;
    .xuqiu_top {
      height: 1rem;
      line-height: 1rem;
      font-weight: bold;
      font-size: 0.3rem;
      position: fixed;
      width: 100%;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
      padding-left: 0.3rem;
      .xuqiu_close {
        position: absolute;
        right: 0.3rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .xuqiu_list {
      max-height: calc(60vh - 2.6rem);
      margin-top: 1.3rem;
      padding: 0 0.3rem 0.2rem 0.3rem;
      overflow: auto;
      .item_title {
        font-size: 0.3rem;
        padding: 0.2rem 0 0 0;
      }
      .item_list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .item {
          width: calc((100% - 0.4rem) / 3);
          height: 0.7rem;
          border: 0.01rem solid #e5e5e5;
          line-height: 0.68rem;
          text-align: center;
          font-size: 0.26rem;
          margin-top: 0.2rem;
          border-radius: 0.06rem;
          margin-right: 0.2rem;
          background: #f6f6f6;
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          &.active {
            background: #fff8f6;
            border-color: #ff410a;
            color: #ff410a;
          }
        }
      }
    }
    .xuqiu_btn {
      height: 1.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.3rem;
      padding-bottom: 0.4rem;
      margin-top: 0.3rem;
      .btn_item {
        // width: calc((100% - 0.2rem) / 2);
        width: 100%;
        text-align: center;
        line-height: 0.9rem;
        border-radius: 0.06rem;
        background: #f6f6f6;
        font-size: 0.34rem;
        font-weight: bold;
        &.sub {
          background: #ff410a;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
